import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Constants from '@/utils/Constants'
import ApiManager from '@/utils/ApiManager'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'DeviceRegistResolutionModal',
  data () {
    return {
      processing: false,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.deviceRegistResolutionModal.active,

      // form
      deviceTypeId: state => state.deviceRegistResolutionModal.targetId,

      // model
      values: state => state.deviceRegistResolutionModal.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),

    // result
    modelNumber () {
      return this.values.modelNumber
    },
    modelName () {
      return this.values.modelName
    },

    // input
    inpWidth: {
      get () {
        return this.values.inpWidth
      },
      set (value) {
        this.setInputValue({
          key: 'inpWidth',
          value: value
        })
      }
    },
    inpHeight: {
      get () {
        return this.values.inpHeight
      },
      set (value) {
        this.setInputValue({
          key: 'inpHeight',
          value: value
        })
      }
    },

    // disabled
    disableConfirmButton () {
      return !Validator.validText(this.inpWidth) ||
        !Validator.validText(this.inpHeight)
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'submit') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      hide: 'deviceRegistResolutionModal/hide',
      setUpdated: 'deviceRegistResolutionModal/setUpdated'
    }),
    ...mapMutations({
      setInputValue: 'deviceRegistResolutionModal/setInputValue',
    }),

    init () {
      // データ更新フラグの初期化
      this.setUpdated(false)
    },

    confirmData () {
      this.showConfirm({
        key: 'submit',
        title: '',
        body: 'この内容で解像度を登録しますか？',
        acceptLabel: '登録'
      })
    },
    postData () {
      this.processing = true

      let parameters = {
        deviceTypeUuid: this.deviceTypeId,
        request: {
          screen_width: this.inpWidth,
          screen_height: this.inpHeight
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['device'],
        ['v1DeviceResolutionPatch'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: '',
              body: '解像度を登録しました。'
            })

            // データ更新フラグを有効
            // 呼び出し元のページで一覧を更新するため
            this.setUpdated(true)

            this.closeModal()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}